<template>
  <commission-form
      :initCommission="initCommission"
      :successMsg="t('commissionCreated')"
      :submitAction="submit"
      enableClearForm
      clearFormOnSubmit
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import CommissionForm from '@/views/hr/commissions/CommissionForm.vue'

import Commission from '@/models/hr/Commission'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'new-commission',
  components: {
    CommissionForm
  },
  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          commissionCreated: 'Commission was created successfully'
        },
        ar: {
          commissionCreated: 'تم انشاء العمولة بنجاح'
        }
      }
    })

    return { t }
  },
  data() {
    return {
      initCommission: new Commission()
    }
  },

  methods: {
    async submit(commission: Commission) {
      try {
        await this.$http.post(Commission.ENDPOINT, commission)
        await this.$router.push(this.$Route.HR_COMMISSIONS)
      } catch (error) {
        return error
      }
    }
  }
})
</script>

<style></style>
